module.exports = __webpack_public_path__ + "static/media/06.05.1.8aaf18a7.webp";